<!-- <a href="product/{{fabricORfinished}}/{{productListingData.product.slug}}/{{productListingData.id}}" target="_blank"> -->

<div class="product_item_ind_cont" >

	<div>
		<div class="similar_products fb-skeleton h-[25px] w-[70%] p-0">
		</div>
		<div class="img_cont fb-skeleton w-[100%] h-[100%] rounded">

			<!-- TODO: do not remove. this is for lazy load image -->
			<!-- <img class="forground" loading="lazy" alt="hero image"
				[lazyLoad]="this.productListingData.product.heroImage"
				[defaultImage]="'./assets/img/default_image_listing.png'" />

			<img class="overlayImage" [@enterAnimation] *ngIf="hoverActive"
				[lazyLoad]="this.productListingData.product.hoverImage"
				[defaultImage]="'./assets/img/default_image_listing.png'" loading="lazy" alt="hover image" /> -->
			<!-- TODO: do not remove. this is for lazy load image. -->
			<div class="forground fb-skeleton md:w-[300px] md:h-[240px] rounded"></div>

		</div>
	</div>

	<!-- fabric only start for desktop -->
	<ng-container *ngIf="!isMobile">
		<div>
			<div class="for_fabric_image_cont for_desktopp fb-skeleton">
				<ng-container >
					<div class="fb-skeleton active"></div>
				</ng-container>
				<div class="fabric_more_count fb-skeleton">
				</div>
			</div>
		</div>
	</ng-container>
	<!-- fabric only for desktop end -->



	<!-- fabric only for mobile start -->

	<ng-container *ngIf="isMobile">
		<div class="for_fabric_image_cont for_mobile fb-skeleton w-[100%] h-[120px] rounded" >
			<ng-container>
			</ng-container>
		</div>
	</ng-container>
	<!-- fabric only for mobile end -->



	<div class="listing_item_info">
		<div class="w-[100%] h-[20px] fb-skeleton rounded">
			<p class="name fb-skeleton">
			</p>

			<p class="price fb-skeleton">

			</p>
		</div>
		<div class="login_for_bulk_price fb-skeleton w-[100%] h-[10px] min-w-[30px] md:min-w-[100px]">

		</div>
		<div class="login_for_bulk_price loggedIn fb-skeleton w-[100%] h-[10px] min-w-[60px] md:min-w-[200px]" >
			<p>
			</p>
		</div>
	</div>

<!--	<div class="circle_image_cont">-->
<!--		<ng-container *ngFor="let relatedProductList of relatedProductList">-->
<!--			<a routerLink="/product/{{fabricORfinished}}/{{relatedProductList.slug}}">-->
<!--				&lt;!&ndash; <span style="background-image: url({{relatedProductList.heroImage}});"></span> &ndash;&gt;-->
<!--				<span>-->
<!--					<img [lazyLoad]="relatedProductList.heroImage" />-->
<!--				</span>-->

<!--			</a>-->
<!--		</ng-container>-->
<!--		<a routerLink="/product/{{fabricORfinished}}/{{productListingData.product.slug}}">-->
<!--			<div class="fabric_more_count for_related_product" *ngIf="excenRelatedProductList.length!=0">-->
<!--				+{{excenRelatedProductList.length}}-->
<!--			</div>-->
<!--		</a>-->
<!--	</div>-->
</div>
